"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const commonPasswords_1 = require("./commonPasswords");
const message = 'This password is too common. Please choose another.';
let Password = class Password {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => String, {
        description: 'Password',
        nullable: false,
    }),
    class_validator_1.IsNotEmpty(),
    class_validator_1.IsNotIn(commonPasswords_1.commonPasswords, {
        message,
    }),
    class_validator_1.NotContains('osmosys', {
        message,
    }),
    class_validator_1.NotContains('yellowbrim', {
        message,
    }),
    class_validator_1.NotContains('yellow brim', {
        message,
    }),
    class_validator_1.MinLength(8, { message: 'Passwords must be 8 or more characters' }),
    class_validator_1.MaxLength(64, { message: 'Passwords may not be longer than 64 characters' }),
    tslib_1.__metadata("design:type", String)
], Password.prototype, "password", void 0);
Password = tslib_1.__decorate([
    type_graphql_1.InputType()
], Password);
exports.Password = Password;
//# sourceMappingURL=Password.js.map